import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { approveRequest, rejectRequest } from 'src/redux/actions/admin';
import { sendNotification } from 'src/redux/actions/notifications';
import { findAllRequest, findAllBatchRequest } from 'src/redux/actions/request';
import { withRouter, Link } from 'react-router-dom';

class Request extends Component {
  render = () => {
    const {
      Layout,
      currentRequests,
      currentBatchRequests,
      previousRequests,
      previousBatchRequests,
      user,
      findAllRequest,
      findAllBatchRequest,
      approveRequest,
      rejectRequest,
      sendNotification,
      push,
      history
    } = this.props;
    return (
      <Layout
        currentRequests={currentRequests}
        previousRequests={previousRequests}
        currentBatchRequests={currentBatchRequests}
        previousBatchRequests={previousBatchRequests}
        user={user}
        findAllRequest={findAllRequest}
        findAllBatchRequest={findAllBatchRequest}
        approveRequest={approveRequest}
        rejectRequest={rejectRequest}
        sendNotification={sendNotification}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentRequests: state.request.currentRequests || [],
  previousRequests: state.request.previousRequests || [],
  currentBatchRequests: state.request.currentBatchRequests || [],
  previousBatchRequests: state.request.previousBatchRequests || [],
  user: state.user.user || {}
});

const mapDispatchToProps = {
  findAllRequest,
  findAllBatchRequest,
  approveRequest,
  rejectRequest,
  sendNotification,
  push
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Request)
);
